import { createFileRoute } from '@tanstack/react-router';

import NewCheckList from '@/modules/hang-tags/pages/NewCheckList';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/settings/hang-tag/check-list/new',
)({
  head: () => ({
    meta: [{ title: 'Novo Check List' }],
  }),
  component: NewCheckList,
});
